import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

const getAdLikeStatus = async (guid: string, payload: AdTypepayload) => {
  const {data}: {data: AdLikeStatusData} = await request.get(
    `/api/v2/store/show-like-status?id=${guid}`,
    {params: payload} as AxiosRequestConfig,
  );

  return data;
};

export default getAdLikeStatus;
